<template>
  <div class="registry page">
    <p class="p">
      Agreeing to share our lives together in front of the people we hold
      dearest in our hearts has always been a dream of our wedding. Many of you
      will have travelled far and wide to share with us in this moment together.
      We also wanted key elements of our wedding to serve as long and lasting
      parts of our lives and our future. The centre pieces adorning the dining
      tables will be used to carry the books and mementos we have collected from
      around the world. To preserve the light in our hearts the chandelier under
      which we will be married will light our future home.
    </p>
    <p class="p">
      Just as our wedding represents the fusion of different cultures and
      practices, so will our home. We know that creating a happy home takes a
      lot of love, time and appreciation for each other. More importantly, we
      know that a home isn’t made just by the people who live in it. It takes
      the love and good wishes of family and friends to make lifelong happy
      memories.
    </p>
    <p class="p">
      We dream of a home together and the pennies or more you give us today will
      be the building blocks to the fulfilment of this wish in the near future.
      Pennies have historically been lucky due to the link that copper and other
      precious metals have as gifts from the gods and the protection they lend
      against bad spirits. As the old saying goes, “Something old, something
      new, something borrowed, something blue, and a penny in the shoe”. So, if
      you wish to include a penny for good luck for our future or a bit more to
      help grow our special home, we will have a guarded card box so that you
      can.
    </p>
  </div>
</template>

<script>
export default {
  name: "Registry"
};
</script>

<style lang="scss"></style>
